<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Edit Role'}}</strong>
        </div>
        <div class="col-md-1">
          <!-- <download :tableId="'roles'" :fileName="'roles-list'"></download> -->
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <form class="form-horizontal" @onsubmit.prevent action>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label">Role</label>
              <input
                type="text"
                class="form-control inmarginbtm"
                placeholder="Role"
                readonly
                v-model="editedRole.role_id"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-3"
            v-for="(section, ind) in sections"
            v-bind:key="ind+'-setion-'+section._id"
          >
            <div class="form-group form-check">
              <div class="checkbox">
                <label :for="'checkbox'+ind" class="form-check-label">
                  <input
                    type="checkbox"
                    :id="'checkbox'+ind"
                    :name="'checkbox'+ind"
                    class="form-check-input"
                    :value="section.id"
                    @click="clickPermission(section.id)"
                    :checked="hasPermission(section.id)"
                  />
                  {{section.name}}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-10">
            <button
              type="button"
              class="btn btn-sm btn-primary pull-right"
              @click="showPinCheck()"
            >Submit</button>
          </div>
        </div>
      </form>
      <PinCheck
        :show.sync="show"
        ref="smallModal"
        v-bind:small="true"
        @submitForm="submitPermissionsForm"
        :cancelClass="'btn btn-secondary'"
      ></PinCheck>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import PinCheck from "@/components/PinCheck.vue";

export default {
  components: { PinCheck },
  name: "RoleEdit",
  created() {
    console.log("edit id", this.$route.params);
    if (this.$route.params.id) {
      console.log("edit id", this.$route.params.id);
      this.id = parseInt(this.$route.params.id);
      this.getRoles();
    } else {
      this.$router.push({
        name: "roles"
      });
    }
  },
  watch: {},
  data() {
    return {
      apiUrl: "roles",
      rawData: [],
      id: 0,
      editedRole: {},
      sections: [],
      selectedSections: [],
      show: false
    };
  },
  methods: {
    reset() {
      this.getRoles();
    },
    getRoles() {
      let _this = this;
      http.get(this.apiUrl, {}, function(error, response) {
        console.log(response);
        _this.rawData = response;
        _this.editedRole = _this.rawData[_this.id];
        _this.sections = _this.rawData[3]["role_sections"];
        _this.getSelectedSections();
      });
    },
    getSelectedSections() {
      this.rawData[this.id]["role_sections"].forEach((el, key) => {
        this.selectedSections.push(el.id); //ele.menu_item;
      });
      console.log(this.selectedSections);
    },
    hasPermission(id) {
      return this.selectedSections.indexOf(id) === -1 ? false : true;
    },
    clickPermission(id) {
      const ind = this.selectedSections.indexOf(id);
      console.log(ind);
      if (ind === -1) {
        this.selectedSections.push(id);
      } else {
        this.selectedSections.splice(ind, 1);
      }
    },
    showPinCheck() {
      this.$refs.smallModal.open();
    },
    submitPermissionsForm() {
      console.log("submitpin entered");
      this.updatePermissions();
    },
    updatePermissions() {
      http.patch(
        "role/" + this.editedRole["_id"]["role_id"],
        { sections: this.selectedSections },
        (error, response) => {
          if (!error) {
            this.$toastr.success("Permissions updated Successfully!", "", {});
            this.$router.push({
              name: "roles"
            });
          } else {
            this.$toastr.error(
              "Oops, something went wrong! Please try again later.",
              "",
              {}
            );
          }
        }
      );
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/acl/roles/edit.vue